import { Construction } from "lucide-react";

export default function AdminPlaceholder({ title, phase = "2" }) {
  return (
    <div className="p-6 md:p-10" data-testid={`admin-placeholder-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <h1 className="text-2xl md:text-3xl font-bold text-slate-900 mb-6">{title}</h1>
      <div className="bg-white border border-slate-200 rounded-xl p-10 text-center">
        <Construction className="w-10 h-10 text-slate-400 mx-auto mb-3" />
        <div className="text-slate-700 font-medium">Coming in next update</div>
        <div className="text-xs text-slate-500 mt-1">Planned for Phase {phase}.</div>
      </div>
    </div>
  );
}
